import React from 'react';
import { Video } from '../Video.interface';
import SingleVideo from '../SingleVideo/SingleVideo';
import { environments } from 'environments/environments';
import { byLatest } from 'libs/functions/order';

class VideoList extends React.Component {
  state = {
    videos: [] as Video[]
  }

  componentDidMount() {
    this.getVideoList();
  }

  getVideoList() {
    fetch(environments.serverURL + '/data/videos.json?anticache=' + Date.now())
      .then(res => res.json())
      .then((res: Video[]) => {
        if (res && res.length) {
          const videos = res.sort(byLatest);
          this.setState({ videos });
        }
      });
  }

  render() {
    const renderVideos = this.state.videos.map((video, index) => <SingleVideo key={index} video={video} />)
    return (
      <div className="section">
        {renderVideos}
      </div>
    );
  }
}

export default VideoList;